import React from 'react'
import { ReactComponent as TickIcon } from '../../assets/svg/MarketplaceFunctions/tick.svg'
import style from './toggle-entries.module.css'

interface IToggleEntries {
  title?: string
  entries: IEntry[]
  handleToggle: (idx: number) => void
  disableToggle?: boolean
}

interface IEntry {
  name: string
  isChecked: boolean
}

interface IRoundedTick {
  isChecked: boolean
  idx: number
  handleToggle: (idx: number) => void
  disableToggle?: boolean
}

const RoundedTick: React.FC<IRoundedTick> = (props) => {
  const { isChecked, idx, handleToggle, disableToggle } = props

  const inlineStyles: React.CSSProperties = {
    backgroundColor: isChecked ? '#0466C8' : '#7E869E40',
  }
  if(disableToggle) {
    inlineStyles.cursor = "not-allowed"
  }

  return (
    <div
      className={style.toggleEntryIcon}
      style={inlineStyles}
      onClick={() => {
        if (!disableToggle) {
          handleToggle(idx)
        }
      }}
    >
      <TickIcon
        width={12}
        height={12}
      />
    </div>
  )
}

export const ToggleEntries: React.FC<IToggleEntries> = (props) => {
  const { title, entries, handleToggle, disableToggle } = props

  return (
    <div className={style.spacingHorizontal}>
      {title ? <h4 className={style.title}>{title}</h4> : null}
      <div style={{ marginTop: 18 }}>
        {entries.map((entry, idx) => {
          const { isChecked, name } = entry
          return (
            <div key={name} className={style.toggleEntryWrapper}>
              <RoundedTick
                isChecked={isChecked}
                handleToggle={handleToggle}
                disableToggle={disableToggle}
                idx={idx}
              />
              <span
                style={{
                  fontSize: 16,
                  color: isChecked ? '#0466C8' : '#000',
                }}
              >
                {name}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
